module.exports = __webpack_public_path__ + "media/images/pc/stores/shibuya/shibuya_concept_02-498812034b3799360497a346baa6441e.jpg";